/**
 * Official ACIS / IBTHM authority seal. Looks up the correct PNG by credential
 * type or by an explicit `kind` prop. Use this anywhere a credential identity
 * needs to be visually authenticated (registry, certificates, profiles, etc.).
 */
const SEAL_META = {
  acis_accredited_member: {
    src: "/seals/acis-accredited-member.png",
    label: "ACCREDITED MEMBER",
    authority: "Accreditation Commission for Integrative Sciences",
  },
  ibthm_board_certified: {
    src: "/seals/ibthm-board-certified.png",
    label: "BOARD CERTIFIED",
    authority: "International Board of Trichology & Holistic Medicine",
  },
  ibthm_licensed: {
    src: "/seals/ibthm-licensed.png",
    label: "LICENSED",
    authority: "International Board of Trichology & Holistic Medicine",
  },
};

// Map a credential type / accreditation type to the right seal kind.
const CREDENTIAL_TO_SEAL = {
  // ACIS — institutional + programmatic both get the Accredited Member seal
  institutional: "acis_accredited_member",
  programmatic:  "acis_accredited_member",
  // IBTHM board certifications
  BCHHP: "ibthm_board_certified",
  BCT: "ibthm_board_certified",
  BCDTS: "ibthm_board_certified",
  "IBTHM-CT": "ibthm_board_certified",
  "IBTHM-Trichologist": "ibthm_board_certified",
  "IBTHM-Holistic": "ibthm_board_certified",
  "IBTHM-Drugless": "ibthm_board_certified",
  // IBTHM licensure
  LHT: "ibthm_licensed",
};

export function sealForCredential(typeOrAccrType) {
  if (!typeOrAccrType) return null;
  return CREDENTIAL_TO_SEAL[typeOrAccrType] || null;
}

const SIZE_PX = {
  xs: 32,
  sm: 56,
  md: 84,
  lg: 120,
  xl: 180,
};

export default function Seal({
  kind,
  credentialType,
  size = "md",
  showLabel = false,
  className = "",
  title,
}) {
  const k = kind || sealForCredential(credentialType);
  if (!k || !SEAL_META[k]) return null;
  const meta = SEAL_META[k];
  const px = SIZE_PX[size] || SIZE_PX.md;
  return (
    <div
      className={`inline-flex flex-col items-center gap-1 ${className}`}
      data-testid={`seal-${k}`}
      title={title || `${meta.label} · ${meta.authority}`}
    >
      <img
        src={meta.src}
        alt={`${meta.label} seal — ${meta.authority}`}
        width={px}
        height={px}
        loading="lazy"
        className="object-contain drop-shadow-sm"
        style={{ width: px, height: px }}
      />
      {showLabel && (
        <span className="text-[10px] uppercase tracking-[0.18em] font-bold text-slate-600">
          {meta.label}
        </span>
      )}
    </div>
  );
}

export { SEAL_META };
